import React from 'react'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import Hero from '../../components/Hero/Hero'
import Residency from '../../components/Residencies/Residency'
import './AboutPage.css'
import AboutCard from '../../components/AboutCard/AboutCard'

const AboutPage = () => {
  return (
    <section className='aboutpage-container'>
        <Header />
        <Hero />
        <Residency />
        <AboutCard />
        {/* <div className='paddings innerWidth aboutpage-content'>
          
          <div className='introduction'>
            <span>INTRODUCTION</span>
            <span>Equilibrium Metro Homes is a dynamic and innovative
               company specializing in building, marketing, and construction services. With 
               a strong commitment to quality, sustainability, and customer
               satisfaction, we aim to create exceptional living spaces that harmonize 
               with their surroundings. Our team of skilled professionals leverages cutting-edge 
               technology, industry expertise, and a customer-centric approach to deliver 
               outstanding results. Equilibrium Metro Homes strives to redefine the standards 
               of excellence in the real estate industry.</span>
          </div>

          <div className='our-vision'>
            <span>OUR VISION</span>
            <span>At Equilibrium Metro Homes Company, our vision is to create standard Values 
              with innovation. We believe in pushing the boundaries of conventional construction 
              practices and embracing innovative solutions to set new benchmarks in the industry. Our vision 
              is rooted in a deep understanding of the evolving needs and aspirations of our 
              clients, and we strive to exceed their expectations by delivering projects that are 
              not only of the highest quality but also incorporate cutting-adge technologies and sustainable 
              practices.
            </span>
          </div>

          <div className='our-mission'>
            <span>OUR MISSION</span>
            <span>At Equilibrium Metro Homes Company, our mission is to be a professional organization 
              that priortizes customer satisfaction and strives for excellence in every aspect of our 
              implementation. We understand that our success lies in the satisfaction of our clients, 
              and we are dedicated to delivering exceptional services that meet their unique needs and exceed their 
              expectation. Customer satisfaction is at the forefront of our mission. We believe in building strong and 
              lasting relationship with our clients based on trust, transparency and open communication.
            </span>
          </div>
          </div> */}
        <Footer />
    </section>
  )
}

export default AboutPage
